import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { LanguageProvider } from './context/LanguageContext';

const loadRuntimeConfig = () => {
  if (window.__CB_CONFIG__) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/config.js';
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load /config.js'));
    document.head.appendChild(script);
  });
};

const bootstrap = async () => {
  try {
    await loadRuntimeConfig();
  } catch (err) {
    console.warn('Runtime config failed to load; falling back to defaults.', err);
  } finally {
    createRoot(document.getElementById('root')).render(
      <StrictMode>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </StrictMode>,
    );
  }
};

bootstrap();
